import { Component } from '@angular/core';

@Component({
  selector: 'app-new-order',
  templateUrl: './new-order.component.html',
  styleUrls: ['./new-order.component.scss'],
})
export class NewOrderComponent {
  selectedView!: string;
  orderId!: number;
  dynamicService: number | null = null;
  stepper: string = 'building';

  getView(event: { view: string; id: number; dynamic_service?: number | null }) {
    this.selectedView = event.view;
    this.stepper = this.selectedView;
    this.orderId = event.id;
    if (event.dynamic_service !== undefined) {
      this.dynamicService = event.dynamic_service;
    }
  }
}
